import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-57fe908f")

_pushScopeId("data-v-57fe908f")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Current ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Future ")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")

  return (_openBlock(), _createBlock(_component_ion_toolbar, { class: "ion-padding-start" }, {
    default: _withId(() => [
      _createVNode(_component_ion_button, {
        "router-link": "/orders",
        "router-direction": "back",
        class: {active: $props.active === 'current'}
      }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_ion_button, {
        "router-link": "/orders/queued",
        class: {active: $props.active === 'queued'}
      }, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
})